module.exports = __webpack_public_path__ + "img/flexible-income-thumbnail.c07a78db.png";